module.exports = __webpack_public_path__ + "img/binxi3.5e665933.png";